import React from 'react';
import { motion } from 'framer-motion';
import { colors, motion as m } from '../brand/tokens';

/** Animated confirmation tick: the disc pops in, then the check draws itself. */
export function SuccessCheck({ size = 88, color = colors.orange }) {
  return (
    <motion.svg
      width={size}
      height={size}
      viewBox="0 0 88 88"
      aria-hidden="true"
      initial={{ scale: 0.4, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={m.spring.bouncy}
      style={{ display: 'block', margin: '0 auto', overflow: 'visible' }}
    >
      <motion.circle
        cx="44"
        cy="44"
        r="52"
        fill="none"
        stroke={color}
        strokeWidth="2"
        initial={{ scale: 0.8, opacity: 0.6 }}
        animate={{ scale: 1.15, opacity: 0 }}
        transition={{ duration: 0.9, ease: 'easeOut', delay: 0.15 }}
        style={{ transformOrigin: '44px 44px' }}
      />
      <circle cx="44" cy="44" r="44" fill={color} />
      <motion.path
        d="M26 45 L39 58 L63 32"
        fill="none"
        stroke={colors.ice}
        strokeWidth="7"
        strokeLinecap="round"
        strokeLinejoin="round"
        initial={{ pathLength: 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration: 0.45, ease: m.ease.standard, delay: 0.2 }}
      />
    </motion.svg>
  );
}

export default SuccessCheck;
